const action = "FOUNDATION_BYOM_REGISTER";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

// payload: { model_id, model_uri, framework, signature, validation,
//            name, description?, visibility?, license?, segment_id? }
export const fetchRequest = (payload)  => ({ type: REQUEST,  payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
